import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {IOfferCardAddressContext} from "../../offer/utils/get_offer_card_address";
import {getAmplitudeOfferListItem} from "./get_amplitude_offer_list_item";
import {AmplitudeItemListName} from "./get_amplitude_view_item_event_properties";

export type AmplitudeViewItemListLocation =
    | "listing_page"
    | "property_page"
    | "investment_page"
    | "rp_apartment_prices_country"
    | "rp_apartment_prices_city"
    | "rp_apartment_prices_district"
    | "rp_apartment_prices_address";

export interface ITrackAmplitudeOfferViewItemListParams {
    addressContext: IOfferCardAddressContext;
    isUspVariant: boolean;
    offers: IOfferListOffer[];
    itemListId?: string;
    itemListName: AmplitudeItemListName;
    location: AmplitudeViewItemListLocation;
    lat?: string;
    lng?: string;
}

const getRegionCoords = (lat?: string, lng?: string): {lat: number; lng: number} | undefined => {
    const parsedLat = lat ? parseFloat(lat) : undefined;
    const parsedLng = lng ? parseFloat(lng) : undefined;

    return parsedLat != null && !isNaN(parsedLat) && parsedLng != null && !isNaN(parsedLng) ? {lat: parsedLat, lng: parsedLng} : undefined;
};

export const trackAmplitudeOfferViewItemList = (params: ITrackAmplitudeOfferViewItemListParams) => {
    const {offers, itemListId, itemListName, location, isUspVariant, addressContext, lat, lng} = params;
    const regionCoords = getRegionCoords(lat, lng);

    trackAmplitudeEvent("view_item_list", {
        ...(itemListId ? {item_list_id: itemListId} : {}),
        item_list_name: itemListName,
        location,
        products: offers.map((offer, index) => getAmplitudeOfferListItem({offer, index, isUspVariant, addressContext, regionCoords}))
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {IOfferCardAddressContext} from "../../offer/utils/get_offer_card_address";
import {getAmplitudeOfferListItem} from "./get_amplitude_offer_list_item";
import {AmplitudeItemListName} from "./get_amplitude_view_item_event_properties";

export type AmplitudeViewItemListLocation =
    | "listing_page"
    | "property_page"
    | "investment_page"
    | "rp_apartment_prices_country"
    | "rp_apartment_prices_city"
    | "rp_apartment_prices_district"
    | "rp_apartment_prices_address";

export interface ITrackAmplitudeOfferViewItemListParams {
    addressContext: IOfferCardAddressContext;
    isUspVariant: boolean;
    offers: IOfferListOffer[];
    itemListId?: string;
    itemListName: AmplitudeItemListName;
    location: AmplitudeViewItemListLocation;
    lat?: string;
    lng?: string;
}

const getRegionCoords = (lat?: string, lng?: string): {lat: number; lng: number} | undefined => {
    const parsedLat = lat ? parseFloat(lat) : undefined;
    const parsedLng = lng ? parseFloat(lng) : undefined;

    return parsedLat != null && !isNaN(parsedLat) && parsedLng != null && !isNaN(parsedLng) ? {lat: parsedLat, lng: parsedLng} : undefined;
};

export const trackAmplitudeOfferViewItemList = (params: ITrackAmplitudeOfferViewItemListParams) => {
    const {offers, itemListId, itemListName, location, isUspVariant, addressContext, lat, lng} = params;
    const regionCoords = getRegionCoords(lat, lng);

    trackAmplitudeEvent("view_item_list", {
        ...(itemListId ? {item_list_id: itemListId} : {}),
        item_list_name: itemListName,
        location,
        products: offers.map((offer, index) => getAmplitudeOfferListItem({offer, index, isUspVariant, addressContext, regionCoords}))
    });
};
